import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import fileApi from '@/shared/api/file/file';
import useNotification from '@/shared/hooks/UseNotification';

const useUpdateFile = () => {
  const { t } = useTranslation();
  const { sendDefaultError, sendNotification } = useNotification();

  const { mutate, isLoading } = useMutation({
    mutationFn: fileApi.putUpdateFile,
    onError: (err) => {
      sendDefaultError(err);
    },
    onSuccess: () => {
      sendNotification({
        header: t('success'),
        message: t('typeSuccessfullyUpdated', { type: t('file_one') }),
        variant: 'success',
      });
    },
  });

  return {
    isUpdatingFile: isLoading,
    updateFile: mutate,
  };
};

export default useUpdateFile;
